import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConstants } from 'src/app/core/constants';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';

@Component({
  selector: 'app-car-pagination',
  templateUrl: './car-pagination.component.html',
  styleUrls: ['./car-pagination.component.scss',],
})
export class CarPaginationComponent {

  perPage = AppConstants.PER_PAGE;
  currentPage: number = AppConstants.ONE;
  @Input() totalRecords: number = AppConstants.ZERO;

  constructor(
    private _activateRoute: ActivatedRoute,
    private _router: Router) {
    this._activateRoute.queryParams.subscribe({
      next: (params) => {
        const { page, } = params;
        if (page) this.currentPage = parseInt(page);
      },
    });
  }

  onPageChange(event: PageChangedEvent) {
    this.currentPage = event.page;
    this._router.navigate([], {
      queryParams: { page: this.currentPage, },
      queryParamsHandling: 'merge',
    });
    window.scroll({ top: 0, left: 0, behavior: 'smooth', });
  }

}
